import {useTranslation} from 'react-i18next';
import React, {useEffect, useState} from 'react';
import _ from 'lodash';
import Grid from '@mui/material/Grid';
import AgyleTextField from '../../components/ui/fields/agyleTextField';
import AgyleDialog from '../../components/modal/agyleDialog';
import InformationBox from '../../components/other/informationBox';

const EditTemporaryPatientModal = ({open, onClose, onSubmit, destinationPatient, patientRef}) => {
    const {t} = useTranslation();
    const initState = {
        temporaryId: '',
        validId: '',
    };
    const [temporaryPatientEditState, setTemporaryPatientEditState] = useState(initState);

    useEffect(() => {
        if (!open) setTemporaryPatientEditState(initState);
        if (open && destinationPatient) {
            setTemporaryPatientEditState({
                ...temporaryPatientEditState,
                validId: destinationPatient,
            });
        }
    }, [open, destinationPatient]);

    const handleChangeTemporaryState = (e) => {
        const {name, value} = e.target;

        setTemporaryPatientEditState({
            ...temporaryPatientEditState,
            [name]: value,
        });
    };

    const handleSubmit = async () => {
        const formState = _.cloneDeep(temporaryPatientEditState);
        try {
            onSubmit(formState).then((res) => {
                if (res) {
                    if (typeof res === 'object') {
                        setTemporaryPatientEditState(initState);
                        onClose();
                        return;
                    }
                    onClose();
                    setTemporaryPatientEditState(initState);
                }
            });
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <AgyleDialog
                onClose={onClose}
                open={open}
                title={t('Edit Temporary Patient')}
                onSave={handleSubmit}
                submitText={t('Edit Patient')}
                width="sm"
                fullWidth
                disableSubmit={temporaryPatientEditState.temporaryId === '' || patientRef?.activeAttendances}
            >
                <>
                    {!destinationPatient &&
                        <InformationBox type="hint">
                            {t('Merge with new created patient')}
                        </InformationBox>
                    }

                    <Grid container direction="row" spacing={2} sx={{mt: 1}}>
                        <Grid item xs={12} sm={destinationPatient ? 6 : 12}>
                            <AgyleTextField
                                label={t('Temporary Patient ID')}
                                name="temporaryId"
                                onChange={handleChangeTemporaryState}
                                value={temporaryPatientEditState?.temporaryId}
                                fullWidth
                            />
                        </Grid>

                        {destinationPatient &&
                            <Grid item xs={12} sm={6}>
                                <AgyleTextField
                                    label={t('Destination Patient ID')}
                                    name="validId"
                                    value={temporaryPatientEditState?.validId}
                                    fullWidth
                                    readOnly
                                />
                            </Grid>
                        }
                    </Grid>
                </>
            </AgyleDialog>
        </>
    );
};

export default EditTemporaryPatientModal;